import {BaseSearchableService} from "./Core/BaseSearchableService";

class RiverService extends BaseSearchableService {
    get Url() { return super.Url + "/rivers"; }
    get ModelName() { return "River"; }
    get PrimaryKeyProperty() { return "riverId"; }

    Get() {
        return this.SendRequest(BaseSearchableService.GET, this.request);
    }

    GetSubtitle(model) {
        return model ? "GNIS ID: " + model.gnisId : "";
    }
}

export const service = new RiverService();

